import { cloudAction } from './cloudAction.js';
import { cloudBaseUrl } from './config';

/**
 * Cloud API 请求类
 * 专门处理 /cloud 开头的 API 请求
 * 与 request.js 完全独立，不影响现有请求逻辑
 */
export default class cloudRequest {
    /**
     * 获取请求的完整URL
     */
    static getFullUrl(address) {
        // cloud API: 开发环境直接使用（通过代理），生产/测试环境需要添加baseUrl
        if (cloudBaseUrl) {
            return `${cloudBaseUrl}/${address}`;
        } else {
            // 开发环境通过 vue.config.js 代理，直接使用相对路径
            return `/${address}`;
        }
    }

    /**
     * GET 请求
     */
    static get(address, params) {
        const url = this.getFullUrl(address);
        return cloudAction({
            url,
            method: 'get',
            params: params || {},  // cloud API 不添加 TenantCode，确保 params 是对象
            headers: {
                'Content-Type': 'application/json',
                Authorization: sessionStorage.getItem('token')
                    ? `Bearer ${JSON.parse(sessionStorage.getItem('token'))}`
                    : ''
            }
        });
    }

    /**
     * POST 请求
     */
    static post(address, data) {
        const url = this.getFullUrl(address);
        return cloudAction({
            url,
            method: 'post',
            data: data,  // cloud API 不添加 TenantCode
            headers: {
                'Content-Type': 'application/json',
                Authorization: sessionStorage.getItem('token')
                    ? `Bearer ${JSON.parse(sessionStorage.getItem('token'))}`
                    : ''
            }
        });
    }

    /**
     * PUT 请求
     */
    static put(address, data) {
        const url = this.getFullUrl(address);
        return cloudAction({
            url,
            method: 'put',
            data: data,
            headers: {
                'Content-Type': 'application/json',
                Authorization: sessionStorage.getItem('token')
                    ? `Bearer ${JSON.parse(sessionStorage.getItem('token'))}`
                    : ''
            }
        });
    }

    /**
     * DELETE 请求
     */
    static delete(address, data) {
        const url = this.getFullUrl(address);
        return cloudAction({
            url,
            method: 'delete',
            data: data,
            headers: {
                'Content-Type': 'application/json',
                Authorization: sessionStorage.getItem('token')
                    ? `Bearer ${JSON.parse(sessionStorage.getItem('token'))}`
                    : ''
            }
        });
    }
}

